import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@common/hooks';
import { selected } from '@modules/core/selectors/logged-user';
import { Celebration } from './types';
import Profile from '@common/components/profile';
import { CelebrationType } from '@common/hooks/use-celebrations';
import Icon from '@common/components/icon';
import LinkWrapper from '@common/components/linkWrapper';

type Props = {
    user: Celebration;
    view: CelebrationType;
};

const CelebrationsWidgetCard: React.FC<Props> = ({ user, view }) => {
    const { t } = useTranslation();
    const loggedUser = useAppSelector(selected);
    const selectedNetwork = useAppSelector((store) => store.network.selected);

    return (
      <div
        className="tw-flex tw-items-center tw-justify-between  tw-py-1.5"
      >
        <LinkWrapper url={`/networks/${selectedNetwork}/users/${user.id}/about`}>
          <Profile size={36} user={user}>
            {view === CelebrationType.Anniversary_Type && (
              <p className="tw-text-gray-custom-430 tw-m-0 tw-text-sm-plus">
                {t('social:anniversary_in_years', { count: user.year })}
              </p>
            )}
          </Profile>
        </LinkWrapper>
        {user.id !== loggedUser.id && (
          <LinkWrapper url={`/conversations/users/${user.id}`}>
            <Icon type="send" className="tw-rotate-[-45deg] tw-text-gray-muted" />
          </LinkWrapper>
        )}
      </div>
    );
};

export default CelebrationsWidgetCard;
